// Helpers for POS UI. Pure functions only — no React/imports beyond stdlib.

export const stripDiacritics = (s) =>
  String(s ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .toLowerCase();

export const matchesSku = (sku, query) => {
  if (!query) return true;
  const q = stripDiacritics(query);
  return (
    stripDiacritics(sku.code).includes(q) ||
    stripDiacritics(sku.name).includes(q) ||
    (sku.barcode && stripDiacritics(sku.barcode).includes(q))
  );
};

const dateFormatter = new Intl.DateTimeFormat("vi-VN", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
  timeZone: "Asia/Ho_Chi_Minh",
});

// DD/MM/YYYY HH:mm — stable across browsers (`toLocaleString` varies).
export const fmtDateTimeFixed = (input) => {
  if (!input) return "—";
  try {
    const d = input instanceof Date ? input : new Date(input);
    if (Number.isNaN(d.getTime())) return "—";
    const parts = dateFormatter.formatToParts(d).reduce((acc, p) => {
      acc[p.type] = p.value;
      return acc;
    }, {});
    return `${parts.day}/${parts.month}/${parts.year} ${parts.hour}:${parts.minute}`;
  } catch {
    return "—";
  }
};

const STATUS_LABELS = {
  open: "Mở",
  paid: "Đã thu",
  voided: "Đã hủy",
  refunded: "Đã hoàn",
  cancelled: "Đã hủy",
};

export const statusVi = (s) => STATUS_LABELS[s] || s || "—";

const STATUS_TONE = {
  paid: "bg-emerald-100 text-emerald-900",
  open: "bg-amber-100 text-amber-900",
  voided: "bg-red-100 text-red-900",
  refunded: "bg-blue-100 text-blue-900",
  cancelled: "bg-stone-200 text-stone-700",
};

export const statusTone = (s) => STATUS_TONE[s] || "bg-stone-100 text-stone-700";

const draftKey = (channel) => `pos-draft-${channel}`;

export const loadDraft = (channel) => {
  try {
    const raw = localStorage.getItem(draftKey(channel));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveDraft = (channel, payload) => {
  try {
    localStorage.setItem(draftKey(channel), JSON.stringify({ ...payload, saved_at: Date.now() }));
    return true;
  } catch {
    return false;
  }
};

export const clearDraft = (channel) => {
  try {
    localStorage.removeItem(draftKey(channel));
  } catch {
    // ignore — quota or disabled storage
  }
};

export const roundPrice = (n) => Math.round(Number(n || 0) * 100) / 100;

// Field labels used by validation toast — keep keys in sync with business-validation.js
export const FIELD_LABELS = {
  branch_id: "Chi nhánh",
  table_no: "Số bàn",
  customer_id: "Khách hàng",
  lines: "Giỏ hàng",
};
